// The app's one UsageTracker (docs/areas/usage.md): screens opened and key
// actions used go to our own server as counters, batched. Member devices and
// signed-out ones never report; the owner's switch lives on the server.
import { api } from '@/runtime'
import { useAccess } from '@/state/access'
import { UsageTracker } from '@/lib/usage'

const device = (): 'phone' | 'desktop' =>
  typeof window !== 'undefined' && window.matchMedia?.('(max-width: 767px)').matches ? 'phone' : 'desktop'

const tracker = new UsageTracker(
  (hits) => api.usageRecord(hits, device()),
  () => !useAccess.getState().member,
)

/** Count one use of a feature: `screen:<route pattern>` or `action:<name>`. */
export const trackUse = (feature: string) => tracker.track(feature)

if (typeof document !== 'undefined')
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') void tracker.flush()
  })
